import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavNoticationComponent } from './nav-notification/nav-notification.component';
import { SharedModule } from '../shared/shared.module';
import { SearchComponent } from './search/search.component';
import { AdvancedSearchComponent } from './advanced-search/advanced-search.component';
import {
  LoadingTopicComponent,
  LoadingComponent,
  NotRecordsFoundComponent,
  TopicsMenubarComponent,
  TypeaheadSearchComponent,
  SortOptionsComponent,
  ToastNotificationComponent,
  ToastNotificationService,
  DescriptionBoxComponent,
  CoveragePreviewComponent,
  LongTermChartComponent,
  ToolbarContentComponent,
  FilterTextComponent,
  SovChartComponent,
  BlockUIComponent,
  ScreenSizeComponent,
  ContentItemsComponent,
  ContentItemsSkeletonComponent,
  SidebarListComponent,
  BadgeComponent,
  CollectionsPanelComponent,
  CollectionItemComponent,
  CollectionCarouselComponent,
  AuthorOutletProfileComponent,
  OutletProfileComponent,
  TopicProfileComponent,
  MarkdownEditorComponent,
  ChatWindowComponent,
  StarToggleComponent,
  EntityFollowHeaderComponent,
  EntityProfileCardComponent,
  ExportFilenameDialogComponent,
  FilterMultiselectComponent,
} from './';

@NgModule({
  imports: [CommonModule, SharedModule],
  declarations: [
    NavNoticationComponent,
    SearchComponent,
    ToastNotificationComponent,
    AdvancedSearchComponent,
    LoadingTopicComponent,
    LoadingComponent,
    NotRecordsFoundComponent,
    TopicsMenubarComponent,
    TypeaheadSearchComponent,
    SortOptionsComponent,
    DescriptionBoxComponent,
    CoveragePreviewComponent,
    LongTermChartComponent,
    ToolbarContentComponent,
    FilterTextComponent,
    SovChartComponent,
    BlockUIComponent,
    ScreenSizeComponent,
    ContentItemsComponent,
    ContentItemsSkeletonComponent,
    SidebarListComponent,
    BadgeComponent,
    CollectionsPanelComponent,
    CollectionItemComponent,
    CollectionCarouselComponent,
    AuthorOutletProfileComponent,
    OutletProfileComponent,
    TopicProfileComponent,
    MarkdownEditorComponent,
    ChatWindowComponent,
    StarToggleComponent,
    EntityFollowHeaderComponent,
  EntityProfileCardComponent,
    ExportFilenameDialogComponent,
    FilterMultiselectComponent,
  ],
  exports: [
    NavNoticationComponent,
    SearchComponent,
    ToastNotificationComponent,
    AdvancedSearchComponent,
    LoadingTopicComponent,
    LoadingComponent,
    NotRecordsFoundComponent,
    TopicsMenubarComponent,
    TypeaheadSearchComponent,
    SortOptionsComponent,
    DescriptionBoxComponent,
    CoveragePreviewComponent,
    LongTermChartComponent,
    ToolbarContentComponent,
    FilterTextComponent,
    SovChartComponent,
    BlockUIComponent,
    ScreenSizeComponent,
    ContentItemsComponent,
    ContentItemsSkeletonComponent,
    SidebarListComponent,
    BadgeComponent,
    CollectionsPanelComponent,
    CollectionItemComponent,
    CollectionCarouselComponent,
    AuthorOutletProfileComponent,
    OutletProfileComponent,
    TopicProfileComponent,
    MarkdownEditorComponent,
    ChatWindowComponent,
    StarToggleComponent,
    EntityFollowHeaderComponent,
  EntityProfileCardComponent,
    ExportFilenameDialogComponent,
    FilterMultiselectComponent,
  ],
  providers: [ToastNotificationService],
})
export class ComponentsModule {}
